import { UiModal, UiToast } from 'components';
import { expression, user } from 'lib';
import auth from '../auth';

const handle = (socket) => {
  socket.on('manage.kick', (msg, { room }, { messages }) => {
    messages.add({
      msg,
      msgType: 'auth.kick',
      tabType: 'chat',
    });
  });
  socket.on('manage.shutup', (msg, { room }, { messages }) => {
    if (user.isLogin() && msg.data_d.xy_user_id === user.getUserId()) {
      auth.updateForbidTime(new Date().getTime() + msg.data_d.minute * 60 * 1000);
    }

    messages.add({
      msg,
      msgType: 'auth.shutUp',
      tabType: 'chat',
    });
  });
  socket.on('manage.recover', (msg, { room }, { messages }) => {
    if (user.isLogin() && parseInt(msg.data_d.xy_user_id, 10) === user.getUserId()) {
      auth.updateForbidTime(0);
    }
    messages.add({
      msg,
      msgType: 'auth.recover',
      tabType: 'chat',
    });
  });
  socket.on('manage.add_admin', (msg, { room }, { messages }) => {
    messages.add({
      msg,
      msgType: 'auth.addAdmin',
      tabType: 'chat',
    });
  });
  socket.on('manage.del_admin', (msg, { room }, { messages }) => {
    messages.add({
      msg,
      msgType: 'auth.delAdmin',
      tabType: 'chat',
    });
  });
  // 管理提示弹窗
  socket.on('toast.admin_waring', (msg) => {
    const { reason } = msg.data;
    UiModal.alert('官方警告', reason, null, '我知道了');
  });
};

export default handle;
